import { apiInstance } from "api/config/axios";
import { IApiResponse } from "api/models/IApiResponse";
import { IGetNodeForLessonProgressRequest } from "api/models/request/IGetNodesForLessonProgressRequest";
import { IGetNodesForLessonProgressResponse } from "api/models/response/IGetNodesForLessonProgressResponse";
import { getApiResponseData } from "api/services/api-service";
import { FileFlat } from "models/FileFlat";
import { IDeleteNodeFileRequest } from "api/models/request/IDeleteNodeFileRequest";
import { IGetNodeFileListRequest } from "api/models/request/IGetNodeFileListRequest";
import { IGetNodeFileGroupsRequest } from "api/models/request/IGetNodeFileGroupsRequest";

const nodeApiBaseUrl = '/node';

export const getNodesForLessonProgress = (request: IGetNodeForLessonProgressRequest & { workspaceId: string }): Promise<IApiResponse<IGetNodesForLessonProgressResponse>> => {
    const url = request.userId ? `${nodeApiBaseUrl}/workspaces/${request.workspaceId}/node-info?lessonProgressId=${request.lessonProgressId}&userId=${request.userId}` : `${nodeApiBaseUrl}/workspaces/${request.workspaceId}/my-node-info?lessonProgressId=${request.lessonProgressId}`;
    return apiInstance.get(url).then((response) => {
        return getApiResponseData(response);
    });
};

export const getNodeFileList = (request: IGetNodeFileListRequest & {workspaceId: string}): Promise<IApiResponse<FileFlat[]>> => {
    return apiInstance.get(`${nodeApiBaseUrl}/workspaces/${request.workspaceId}/node-files`, {params: {resourceType: request.resourceType}}).then((response) => {
        return getApiResponseData(response);
    });
};

export const getNodeFileGroups = (request: IGetNodeFileGroupsRequest & {workspaceId: string}): Promise<IApiResponse<string[]>> => {
    return apiInstance.get(`${nodeApiBaseUrl}/workspaces/${request.workspaceId}/node-files/groups`, {params: {resourceType: request.resourceType}}).then((response) => {
        return getApiResponseData(response);
    });
};

export const deleteNodeFile = (request: IDeleteNodeFileRequest & {workspaceId: string}): Promise<IApiResponse<any>> => {
    return apiInstance.delete(`${nodeApiBaseUrl}/workspaces/${request.workspaceId}/node-files/${request.fileId}`).then((response) => {
        return getApiResponseData(response);
    });
};